module.exports = __webpack_public_path__ + "img/newchris-41.bc23cc44.jpg";